import {PARAM_TYPE_MAP} from "../../constant/datasource";
import {assembleWebComponentTree, parseWebComponentTree, PROP_SUFFIX_CONNECTOR} from "../common";
import {uuid4} from "../index";
import {
  deleteRenderComponentById,
  getConfigByInstanceId,
  getRenderComponentById,
  getRenderComponentsById,
  setRenderComponentById,
  setRenderComponents,
  updateRenderCompAttr,
  updateRenderComponentAttr
} from "../../store/common/action";
import {userStore} from "../../store";
import {genRuntimeDynamicCss} from "../tailwindcss";
import {attrWatchHandler} from "../functionParser/functionImpl/componentStoreFunctionImpl";
import {getKeyValue} from "../../store/common/localStorageManager";
import {RenderDataSource} from "../../store/data/data.types";

/**
 * 普通组件动态替换数据源数据
 * @param component 组件ast
 * @param renderData 数据
 * @param instanceId
 * @param tree
 */
export const ordinaryComponents = (component, renderData, instanceId, tree?) => {
  const componentCopy = _cloneDeep(component);

  if (!componentCopy.attrs) return;

  // 处理组件属性绑定
  Object.keys(componentCopy.attrs).forEach(key => {
    const attr = componentCopy.attrs[key];
    const {fieldType, fieldProp, bind} = attr;
    // 没有绑定属性
    if ((!fieldType && !fieldProp) || !bind) return;

    const dataIndex = _get(componentCopy, 'dataIndex', 0);
    const dataValue = _get(renderData, ['items', dataIndex]);
    // 根据字段类型设置属性值
    switch (fieldType) {
      case PARAM_TYPE_MAP().FORM_FIELD:
        // 不用 ||：数字 0、false 等为有效值，|| 会误落到后备值
        let formValue = _get(dataValue, ['data', fieldProp]);
        if (formValue === undefined || formValue === null) {
          formValue = _get(dataValue, [fieldProp], "");
        }
        // 属性绑定需要回显的组件类型列表
        if (['text', 'input', 'amount', 'pay', 'generator', 'data-selection', 'rbac', 'selectChoices', 'date'].includes(_get(componentCopy, ['type']))) {
          if (['input'].includes(_get(componentCopy, ['type'])) && ['checkbox', 'radio'].includes(_get(componentCopy, ['attrs', 'inputType', 'value']))) {
            if (Array.isArray(formValue) && _get(componentCopy, ['attrs', 'inputType', 'value']) === 'checkbox') {
              _set(componentCopy, ['attrs', 'checked', 'value'], formValue.includes(attr.value));
              const index = formValue.indexOf(attr.value);
              if (index !== -1) {
                formValue = formValue[index];
              } else {
                formValue = attr.value;
              }
            }
            if (_get(componentCopy, ['attrs', 'inputType', 'value']) === 'radio') {
              if (attr.value === formValue) {
                radio_check(component, instanceId);
              }
            }
            _set(componentCopy, ['attrs', fieldProp, 'value'], attr.value);
          } else {
            // NOTE：增加了textValue判断
            if (key === 'textValue' && _has(dataValue, ['data', `view_${fieldProp}`]) && !['selectChoices'].includes(_get(componentCopy, ['type']))) {
              _set(componentCopy, ['attrs', 'showTitle', 'value'], _get(dataValue, ['data', `view_${fieldProp}`]));
            }
            _set(componentCopy, ['attrs', fieldProp, 'value'], _get(dataValue, ['data', `${fieldProp}`]));
          }
        }
        attr.value = formValue;
        componentCopy.dynamicCss = genRuntimeDynamicCss(
          component.dynamicCss,
          key,
          formValue,
          componentCopy
        );
        break;

      case PARAM_TYPE_MAP().CURRENT_USER:
        let userValue = getUserInfo(fieldProp);
        if (attr.type === 'string') {
          userValue = String(userValue);
        }
        attr.value = userValue;
        componentCopy.dynamicCss = genRuntimeDynamicCss(
          component.dynamicCss,
          key,
          userValue,
          componentCopy
        );

        break;

      case PARAM_TYPE_MAP().PAGING_PARAMS:
        attr.value = _get(renderData, ['paging', fieldProp]);
        break;

      case PARAM_TYPE_MAP().DATASOURCE_ATTR:
        attr.value = _get(renderData, ['items']);
        break;

      case PARAM_TYPE_MAP().FORM_ROW:
        if (dataValue) {
          const row = _cloneDeep({...dataValue, ..._get(dataValue, "data")});
          delete row["data"];
          delete row["form"];
          attr.value = row;
        }
        break;
    }
  });
  // 处理组件树或直接设置渲染组件
  if (tree) {
    componentCopy.children = initRenderTree(
      componentCopy.children,
      renderData,
      instanceId,
      componentCopy
    );
    tree.push(componentCopy);
  } else {
    setRenderComponentById(instanceId, componentCopy.prop, componentCopy);
  }

};


export function getPageInfo(renderData, fieldProp) {
  let pageInfo = {
    page: renderData.userId,
    limit: userStore.state.userName,
    total: userStore.state.userAvatar
  }
  return pageInfo[fieldProp];
}

export function getUserInfo(fieldProp) {
  let userInfo = {
    id: userStore.state.userId || getKeyValue('userId'),
    name: userStore.state.userName || getKeyValue('userName'),
    avatar: userStore.state.userAvatar || getKeyValue('userAvatar'),
    userType: userStore.state.userType || getKeyValue('userType'),
  }
  console.log("获取的用户信息：", userInfo[fieldProp])
  return userInfo[fieldProp];
}


/**
 * 组件触发自定义属性change
 * @param component
 * @param instanceId
 */
export const dataComponentAttr = async (component, instanceId) => {
  if (_get(component, ['attrs'])) {
    Object.keys(component.attrs).map(async key => {
      await attrWatchHandler(component, key, instanceId);
    })
  }
}

/**
 * 循环区域组件copy
 * @param component 组件ast
 * @param parent
 * @param tree
 * @param renderData
 * @param instanceId
 */
export const nestedComponent = (component, parent, tree, renderData, instanceId) => {
  const componentDef = _cloneDeep(component);
  initNodeDataIndex(component, parent);

  // 获取数据源列表，优先使用组件固定配置
  let dataList =
    _get(componentDef, ['attrs', 'cycleMode', 'value']) === 'followNormalArray'
      ? _get(componentDef, ['attrs', 'dataList', 'value'], [])
      : _size(_get(renderData, ['items'])) > 0
        ? renderData.items
        : _get(componentDef, ['attrs', 'frequency', 'value'], 0);
  // 循环区域组件处理
  if (component.type === 'cyclic-region') {
    // if (!renderData.items && dataList.length === 0) {
    //   let nestedRenderData = getRenderDataSource(instanceId,component.dataSource);
    //   dataList =  _size(_get(nestedRenderData, ['items'])) > 0
    //     ? nestedRenderData.items
    //     : [];
    //
    //   renderData = nestedRenderData;
    // }
    // 根据数据源长度动态设置循环次数
    if (component.dataSource || _get(componentDef, ['attrs', 'cycleMode', 'value']) === 'followNormalArray') {
      component.attrs['frequency'].value = dataList.length || dataList;
    }
    if (_size(_get(renderData, ['items'])) > 0) {
      component.attrs['skeletonScreen'].value = false;
    }
    let frequency = Number(_get(component, ['attrs', 'frequency', 'value'], 0));
    const paging = _get(renderData, ['paging'], null);
    const rollRaw = _get(renderData, ['roll'], false);
    const roll = rollRaw === true || rollRaw === "true";
    const realItemLen = _get(renderData, ['items', 'length'], 0);
    let startOffset = 0;
    let loopCount = 0;
    if (paging && roll) {
      let { page, size } = paging;
      size = Math.max(Number(size) || 10, 1);
      page = Number(page) || 1;
      startOffset = Math.max((page - 1) * size, 0);
      const pageMaxCanTake = frequency > 0 ? Math.min(size, frequency) : size;
      loopCount = Math.min(pageMaxCanTake, Math.max(0, realItemLen - startOffset));
    } else {
      startOffset = 0;
      // frequency>0做限制；frequency=0不限制，取实际数组长度
      loopCount = realItemLen > 0 ? realItemLen : frequency;
      // console.log("【普通模式】loopCount:", loopCount);
    }
    // 生成循环实例
    for (let i = 0; i < loopCount; i++) {
      const globalIdx = startOffset + i;
      const componentCopy = initCyclicRegionCopy(
        component,
        componentDef,
        renderData.items,
        globalIdx,
        instanceId
      );
      tree.push(componentCopy);
    }
  }
  // 普通组件处理
  else {
    ordinaryComponents(component, renderData, instanceId, tree);
  }
};

/**
 * 初始化tree
 * @param componentTree
 * @param parent
 * @param renderData
 * @param instanceId
 */
export const initRenderTree = (componentTree, renderData, instanceId, parent?) => {
  let tree = [];
  for (let component of componentTree) {
    nestedComponent(component, parent, tree, renderData, instanceId);
  }
  return tree;
}


/**
 * 拷贝ConfigASt 并给拷贝的ast增加下标
 * @param component
 * @param componentDef
 * @param renderData
 * @param index
 */
export const initCyclicRegionCopy = (component, componentDef, renderData, index, instanceId) => {
  // 创建组件副本并设置基础数据索引
  const componentCopy = {
    ..._cloneDeep(component),
    dataIndex: index,
    dataId: renderData[index]?._id || index,
    prop: `${componentDef.prop}${PROP_SUFFIX_CONNECTOR}${uuid4()}`
  };

  // 处理子组件
  componentCopy.children = componentCopy.children.map(child => {
    const isDataSourceMatch = _get(child, 'dataSource') === _get(component, 'dataSource');

    return {
      ...child,
      // 同步数据源索引
      ...(isDataSourceMatch && {
        dataIndex: componentCopy.dataIndex,
        dataId: componentCopy.dataId
      }),
      // 更新父组件引用和唯一标识
      parent: componentCopy.prop,
      prop: `${child.prop}${PROP_SUFFIX_CONNECTOR}${uuid4()}`
    };
  });

  // 递归初始化子组件树
  componentCopy.children = initRenderTree(
    componentCopy.children,
    renderData,
    instanceId,
    componentCopy
  );
  return componentCopy;
};


/**
 * 递归获取指定节点下的所有子节点prop（不包含自身）
 * @param {Map} map 节点数据的Map集合
 * @param {string} nodeId 起始节点ID
 * @returns {string[]} 所有子节点prop的数组
 */
const getPureChildProps = (map, nodeId) => {
  const result = [];
  // 防御性检查（直接使用map.get()判断）
  if (map && !map.get(nodeId)) {
    console.warn(`节点 ${nodeId} 不存在`);
    return result;
  }

  // 递归收集子节点（跳过自身）
  function collectChildProps(id) {
    const currentNode = map.get(id);
    if (!currentNode?.children) return;

    currentNode.children.forEach(child => {
      result.push(child.prop); // 只添加子节点的prop
      collectChildProps(child.prop); // 继续递归
    });
  }

  collectChildProps(nodeId);
  return result;
}

/**
 * 递归获取指定节点下的所有子节点prop（包含自身）
 * @param {Map} map 节点数据的Map集合
 * @param {string} nodeId 起始节点ID
 * @returns {string[]} 包含自身在内的所有子节点prop的数组
 */
export const getAllChildPropsWithSelf = (map, nodeId) => {
  const result = [];
  // 防御性检查（直接使用map.get()判断）
  if (map && !map.get(nodeId)) {
    console.warn(`节点 ${nodeId} 不存在`);
    return result;
  }

  // 递归收集节点（包含自身）
  function collectProps(id) {
    const currentNode = map.get(id);
    if (!currentNode) return;

    // 核心修改：先把当前节点的prop加入结果（包含自身）
    result.push(currentNode.prop);

    // 再递归处理子节点
    if (!currentNode.children) return;
    currentNode.children.forEach(child => {
      collectProps(child.prop); // 继续递归子节点
    });
  }

  collectProps(nodeId);
  return result;
}


/**
 * 递归获取指定节点下prop包含目标值的所有子节点prop（包含自身）
 * @param {Map} map 节点数据的Map集合
 * @param {string} nodeId 起始节点ID
 * @param {string} targetProp 要匹配的目标prop值（包含匹配）
 * @returns {string[]} prop包含目标值的节点prop数组
 */
export const getChildPropsIncludeTarget = (map, nodeId, targetProp) => {
  const result = [];

  // 检查：确保参数合法
  if (!map || !(map instanceof Map)) {
    console.warn('参数错误：map必须是Map实例');
    return result;
  }
  if (typeof nodeId !== 'string' || typeof targetProp !== 'string') {
    console.warn('参数错误：nodeId和targetProp必须是字符串类型');
    return result;
  }
  if (!map.get(nodeId)) {
    console.warn(`节点 ${nodeId} 不存在于Map中`);
    return result;
  }

  // 递归收集prop包含目标值的节点
  function collectIncludeProps(id) {
    const currentNode = map.get(id);
    if (!currentNode) return;
    if (currentNode.prop.includes(targetProp)) {
      result.push(currentNode.prop);
    }

    // 无论当前节点是否匹配，都递归遍历子节点
    if (currentNode.children && Array.isArray(currentNode.children)) {
      currentNode.children.forEach(child => {
        collectIncludeProps(child.prop);
      });
    }
  }

  collectIncludeProps(nodeId);
  return result;
};

/**
 * 删除map指定节点
 * @param map
 * @param prop
 * @param instanceId
 */
export const deletePureChild = (map, prop, instanceId) => {
  const result = getPureChildProps(map, prop);
  if (result.length > 0) {
    result.forEach(childProp => {
      deleteRenderComponentById(instanceId, childProp);
    })
  }
}

/**
 * 生成随机prop
 * @param component
 * @param parent
 */
export const initNodeDataIndex = (component, parent) => {
  const hasParent = parent !== undefined;
  const isDataSourceDifferent =
    hasParent && _get(component, 'dataSource') !== _get(parent, 'dataSource');

  // 设置数据索引和数据源
  if (isDataSourceDifferent) {
    component.parentDataIndex = parent?.dataIndex || '0';
    component.parentDataSource = parent?.dataSource;
  } else if (hasParent) {
    component.dataIndex = parent.dataIndex;
  }

  // 处理组件prop后缀
  const shouldAppendSuffix =
    hasParent &&
    parent.prop?.includes(PROP_SUFFIX_CONNECTOR) &&
    !component.prop.includes(PROP_SUFFIX_CONNECTOR);

  if (shouldAppendSuffix) {
    component.prop = `${component.prop}${PROP_SUFFIX_CONNECTOR}${uuid4()}`;
    component.parent = parent.prop;
  }
};


export const boardComponent = (instanceId, component, renderData) => {
  const renderTreeMap = getRenderComponentsById(instanceId);
  const renderTreeMapCopy = _cloneDeep(renderTreeMap);
  let rollFlag = false;
  let renderDataCopy = new RenderDataSource();
  if (!component || !renderTreeMapCopy) return;
  const designConfig = getConfigByInstanceId(instanceId);
  const boardConfig = designConfig.components.find(item => {
    return item.prop === component.prop
  })
  // 获取父节点判断是否是分页组件
  const boardParent = renderTreeMap.get(component.parent)
  if (boardParent && boardParent.type === 'pagination') {
    rollFlag = _get(boardParent, ['attrs', 'paginationType', 'value']) === 'roll'
  }
  if (boardConfig) {
    for (const comp in boardConfig.children) {
      let compObj = renderTreeMapCopy.get(component.children[comp]?.prop) || designConfig.components.find(item => {
        return item.prop === boardConfig.children[comp].prop;
      })
      // 检查是否为需要处理的循环区域组件
      const isCyclicRegion =
        compObj &&
        compObj.type === "cyclic-region" &&
        (
          _size(renderData?.items ?? []) > 0 || // 若 renderData/items 不存在，默认空数组
          _get(compObj, 'attrs.cycleMode.value') === 'followNormalArray' ||
          _get(compObj, ['attrs', 'frequency', 'value']) > 1
        );
      if (isCyclicRegion || (compObj && compObj.prop.startsWith('p'))) {
        const pageIndex = Number(_get(boardParent, ['attrs', 'pageIndex', 'value'], 1)) || 1;
        const isAppend = rollFlag && pageIndex > 1;
        // 普通分页 / 滚动分页首页：覆盖旧节点；滚动分页下一页：保留已有节点
        if (!isAppend) {
          deletePureChild(renderTreeMap, compObj.parent, instanceId);
        }
        // 重新组装组件树
        const instanceConfig = getConfigByInstanceId(instanceId);
        const root = {};
        assembleWebComponentTree(instanceConfig.components, compObj.parent, root);
        _set(root, 'attrs', component.attrs);
        const size = Math.max(Number(_get(renderData, ['paging', 'size'], 10)) || 10, 1);
        const allItems = _cloneDeep(_get(renderData, ['items'], []) || []);
        if (rollFlag) {
          // 滚动分页始终传累计全量 items，用真实页码计算 dataIndex（第2页 10~19）
          renderDataCopy.items = allItems;
          renderDataCopy.paging = {
            page: pageIndex,
            size,
            total: _get(renderData, ['paging', 'total'], 0),
            append: isAppend,
          };
          renderDataCopy['roll'] = true;
        }
        const tree = initRenderTree([root], rollFlag ? renderDataCopy : renderData, instanceId);
        const list = [];
        parseWebComponentTree(tree, list);
        console.log("list-----------------------------------",list)
        const board = setRenderComponents(instanceId, list);
        if (board) {
          let upBoard = board;
          if (isAppend) {
            upBoard = getRenderComponentById(instanceId, board.prop) || board;
            upBoard.children = [...(upBoard.children || []), ...(board.children || [])];
          }
          setRenderComponentById(instanceId, upBoard.prop, upBoard);
        }
      }
    }
  }
};
// 构建组件数据对象
export const buildComponentData = (domainDataList: any[], total: number) => {
  if (_size(domainDataList) > 0) {
    domainDataList.forEach(item => {
      item = Object.assign(item, _get(item, "data"));
      delete item["data"];
      delete item["form"];//去掉数据中的form结构
    })
  }
  return {
    items: domainDataList || [],
    total: total || 0
  }
}


// 设置单选AST中的checked 为选中
export const radio_check = async (data, instanceId) => {
  const components = getRenderComponentsById(instanceId);
  // 遍历整个页面组件
  components.forEach(component => {
    for (const key of Object.keys(component.attrs)) {
      // 找到同一个分组的单选按钮，排除自己的
      if (data.prop !== component.prop && component.attrs[key]["value"] === _get(data, "attrs.name.value", "---")) {
        // 把除自己外的单选按钮设置为未选中状态
        updateRenderCompAttr(instanceId, component, "checked", false);
      }
    }
  })
  // 自己本身设置为选中
  await updateRenderCompAttr(instanceId, data, "checked", true);
  const parentComp = getRenderComponentById(instanceId, data.parent)
  await updateRenderComponentAttr(instanceId, parentComp, 'verifyState', !_get(parentComp, ['attrs', 'verifyState', 'value']))
}
